import { render, staticRenderFns } from "./HMImageIcon.vue?vue&type=template&id=836be3a2&scoped=true&"
import script from "./HMImageIcon.vue?vue&type=script&lang=js&"
export * from "./HMImageIcon.vue?vue&type=script&lang=js&"
import style0 from "./HMImageIcon.vue?vue&type=style&index=0&id=836be3a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836be3a2",
  null
  
)

export default component.exports